export const KINDS = {
  DEFAULT: 'Default',
  PRIMARY: 'Primary',
} as const

export const SHAPE_TYPES = {
  DEFAULT: 'Default',
  CIRCLE: 'Circle',
} as const
